<template>
    <div>
        <AboutMeMobile />
        <AchievementHolderMobile :key="achievement" v-for="achievement in achievements" :title="achievement[0]" :positions="achievement[1]"/>
        <SkillsMobile />
    </div>
</template>

<script>
import AboutMeMobile from '../mobile/AboutMeMobile.vue'
import AchievementHolderMobile from '../mobile/AchievementHolderMobile.vue'
import SkillsMobile from '../mobile/SkillsMobile.vue'

export default {
  name: 'Mobile',
  components: {
    AboutMeMobile,
    AchievementHolderMobile,
    SkillsMobile
  },
  props: {
    achievements: {
      type: Array,
      required: true
    }
  }
}
</script>
